<template>
  <section id="" class="font-ww-medium">
    <div class="w-full px-3">
      <h2 class="max-w-screen-md mx-auto mt-6 mb-4 text-center h2" v-html="sectionTitle">

      </h2>
    </div>
    <div class="flex flex-wrap overflow-hidden">
      <!-- Image Blocks -->
      <div v-for="(image, index) in images"  :class="index < 6 ? 'p-1.5 w-1/3 md:w-1/6 overflow-hidden' : 'p-1.5 w-full md:w-1/4 overflow-hidden'" :key="index" class="">
        <nuxt-img class="w-full" width="325" height="494" loading="lazy" format="webp" :alt="image.alt"
                  :src="image.src"  sizes="xs:100px sm:160px md:200px lg:231px xl:220px 2xl:325px"/>
      </div>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  sectionTitle: {
    type: String,
    default: 'Influencers & Celebrities Love this Coffee…'
  },
  images: {
    type: Array,
    default: () => [
      {src: '/assets/images/imageLine1.jpg', alt: 'image1'},
      {src: '/assets/images/imageLine2.jpg', alt: 'image2'},
      {src: '/assets/images/imageLine3.jpg', alt: 'image3'},
      {src: '/assets/images/imageLine4.jpg', alt: 'image3'},
      {src: '/assets/images/imageLine5.jpg', alt: 'image5'},
      {src: '/assets/images/imageLine6.jpg', alt: 'image6'},
      {src: '/assets/images/imageLine7.jpg', alt: 'image7'},
      {src: '/assets/images/imageLine8.jpg', alt: 'image8'},
      {src: '/assets/images/imageLine9.jpg', alt: 'image9'},
      {src: '/assets/images/imageLine10.jpg', alt: 'image10'},
      {src: '/assets/images/imageLine11.jpg', alt: 'image11'},
      {src: '/assets/images/imageLine12.jpg', alt: 'image12'}
    ]
  }
});

defineBuilderComponent({
    friendlyName: "ImageLine2",
    inputs: [
        {
            name: "sectionTitle",
            type: "richText",
            defaultValue: "Influencers & Celebrities Love this Coffee…"
        },
        {
            name: "images",
            type: "list",
            defaultValue: [
                {
                    src: "/assets/images/imageLine1.jpg",
                    alt: "image1"
                },
                {
                    src: "/assets/images/imageLine2.jpg",
                    alt: "image2"
                },
                {
                    src: "/assets/images/imageLine3.jpg",
                    alt: "image3"
                },
                {
                    src: "/assets/images/imageLine4.jpg",
                    alt: "image4"
                },
                {
                    src: "/assets/images/imageLine5.jpg",
                    alt: "image5"
                },
                {
                    src: "/assets/images/imageLine6.jpg",
                    alt: "image6"
                },
                {
                    src: "/assets/images/imageLine7.jpg",
                    alt: "image7"
                },
                {
                    src: "/assets/images/imageLine8.jpg",
                    alt: "image8"
                },
                {
                    src: "/assets/images/imageLine9.jpg",
                    alt: "image9"
                },
                {
                    src: "/assets/images/imageLine10.jpg",
                    alt: "image10"
                },
                {
                    src: "/assets/images/imageLine11.jpg",
                    alt: "image11"
                },
                {
                    src: "/assets/images/imageLine12.jpg",
                    alt: "image12"
                }
            ],
            subFields: [
                {
                    name: "src",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "alt",
                    type: "string"
                }
            ]
        }
    ]
});
</script>